import _ from 'lodash';
import getSlug from 'speakingurl';
import PropTypes from 'prop-types';
import { Image, FadeInAnimation, LinkUnderlineAnimation } from '../../shared';
import useResponsive from '../../../../utils/responsive';

const RoomTypeAboutBuilding = (props) => {
    const { selectedRoomType, buildings } = props;
    const { isMobile, isTablet } = useResponsive();
    const buildingName = _.get(selectedRoomType, 'buildingName');
    const buildingDescription = _.get(selectedRoomType, 'buildingDescription');
    const buildingId = _.get(selectedRoomType, 'buildingId');
    const urlFriendlyBuildingName = getSlug(buildingName);

    let buildingImage = null;
    let cityName = null;
    _.map(buildings, (building) => {
        if (_.get(building, 'id') === buildingId) {
            buildingImage = _.get(building, 'images[0]');
            cityName = _.get(building, 'city');
        }
    });

    return (
        <div id="about-building-section">
            <FadeInAnimation>
                <div>
                    <h3 className='room-type-about-building-header3'>About the Building</h3>
                </div>
            </FadeInAnimation>
            <Image
                src={buildingImage}
                alt={buildingName}
                width="100%"
                // eslint-disable-next-line no-nested-ternary
                height={isMobile ? 250 : isTablet ? 450 : 650}
                className="card-image"
                isOldImage
            />
            <FadeInAnimation>
                <div>
                    <h4 className='room-type-about-building-header4'>{buildingName}</h4>
                    <h5 className='room-type-about-building-city-text'>{cityName}</h5>
                    <p className='room-type-about-building-details'>
                        {buildingDescription}
                    </p>
                </div>

                <div className='room-type-about-building-lLink-container'>
                    <LinkUnderlineAnimation
                        id="learn_more_about_building"
                        href={`/buildings/${urlFriendlyBuildingName}/${buildingId}`}
                    >
                        Learn More About the Building
                    </LinkUnderlineAnimation>
                </div>
            </FadeInAnimation>
        </div>
    );
};

export default RoomTypeAboutBuilding;

RoomTypeAboutBuilding.propTypes = {
    selectedRoomType: PropTypes.object,
    buildings: PropTypes.object,
};

